module.exports = __webpack_public_path__ + "img/1582783769.210c8cb7.jpg";